export default "__VITE_ASSET__720e6184__"